/**
 * =============================================================================
 * 如何增加「页面内容管理 → 新增」里的下拉项
 * =============================================================================
 *
 * 1) 在本文件里做两件事（缺一不可）：
 *    - 在 PAGE_CONTENT_KEY_OPTIONS 里追加一行：{ value: '你的key', label: '下拉里显示的说明' }
 *      · value 必须与数据库 site_page_content.content_key 一致（英文/下划线，全局唯一）
 *    - 在 PAGE_CONTENT_LIST_LABELS 里追加同一 key：列表「页面」列显示的中文简称
 *
 * 2) 类型分流（编辑时进哪个界面）：
 *    - 普通单页（一段富文本 HTML）：只要做完第 1 步即可。
 *      保存后点「编辑」会进 PageContentGenericEditView；小程序用 GET /api/mp/pages/{key} 取内容。
 *    - 结构化页（JSON + 专用表单）：还要改 isStructuredPageContentKey、PageContentEditView、
 *      对应 *ManageView.vue、以及 PageContentView.vue 里 onSubmit 新建分支（参考 join_notice）。
 *
 * 3) 可选：在数据库 VIP.sql / 初始化脚本里为演示插入一行（非必须，也可用后台「新增」创建）。
 * =============================================================================
 */

/** 下拉选项：value = 库里的 content_key（用户只看 label） */
export const PAGE_CONTENT_KEY_OPTIONS = [
  { value: 'about', label: '关于我们（协会简介 / 章程 / 荣誉 · 专用编辑）' },
  { value: 'meeting', label: '专业会议（多标签列表 · 专用编辑）' },
  { value: 'join_notice', label: '申请须知（入会说明 · 专用编辑）' },
  { value: 'award', label: '表彰公示（文档 / 文章 · 专用编辑）' },
  { value: 'contact', label: '联系我们（单页图文）' },
  { value: 'agreement_user', label: '用户协议（单页图文）' },
  { value: 'agreement_privacy', label: '隐私政策（单页图文）' },
  { value: 'mine_about', label: '小程序「关于」页（单页图文）' },
  // 示例：单页富文本 — 在本文件与 PAGE_CONTENT_LIST_LABELS 各加一行即可
  // { value: 'fee_notice', label: '会费说明（单页图文）' },
]

/** 列表「页面」列：与 PAGE_CONTENT_KEY_OPTIONS 的 value 一一对应 */
export const PAGE_CONTENT_LIST_LABELS = {
  about: '关于我们',
  about_tabs: '关于我们',
  meeting: '专业会议',
  meeting_tabs: '专业会议',
  join_notice: '申请须知',
  award: '表彰公示',
  award_list: '表彰公示',
  contact: '联系我们',
  agreement_user: '用户协议',
  agreement_privacy: '隐私政策',
  mine_about: '小程序关于',
  // fee_notice: '会费说明',
}

export function getPageContentListLabel(key) {
  const k = String(key || '').trim()
  return PAGE_CONTENT_LIST_LABELS[k] || k || ''
}

/** 结构化：新建模板 + 专用编辑页 */
export function isStructuredPageContentKey(key) {
  const k = String(key || '').trim()
  return (
    k === 'about' ||
    k === 'about_tabs' ||
    k === 'meeting' ||
    k === 'meeting_tabs' ||
    k === 'join_notice' ||
    k === 'award' ||
    k === 'award_list'
  )
}

export function structuredPageLabel(key) {
  const k = String(key || '').trim()
  const m = {
    about: '关于我们',
    about_tabs: '关于我们',
    meeting: '专业会议',
    meeting_tabs: '专业会议',
    join_notice: '申请须知',
    award: '表彰公示',
    award_list: '表彰公示',
  }
  return m[k] || k
}

export function isAwardStructuredKey(k) {
  const x = String(k || '').trim()
  return x === 'award' || x === 'award_list'
}

/** 关于我们：库里的 key 可能是 about 或旧版 about_tabs */
export function isAboutStructuredKey(k) {
  const x = String(k || '').trim()
  return x === 'about' || x === 'about_tabs'
}

/** 专业会议 */
export function isMeetingStructuredKey(k) {
  const x = String(k || '').trim()
  return x === 'meeting' || x === 'meeting_tabs'
}
